import { render, staticRenderFns } from "./BaseWidget.vue?vue&type=template&id=33f7de8e"
import script from "./BaseWidget.vue?vue&type=script&lang=js"
export * from "./BaseWidget.vue?vue&type=script&lang=js"
import style0 from "./BaseWidget.vue?vue&type=style&index=0&id=33f7de8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports